import { cn } from '@/lib/utils';
import { PAYMENT_MODES, type PaymentMode } from '@/lib/payment-modes';

/** Les trois états visuels de la maquette pour la cotisation d'un membre. */
export type MemberStatus = 'paye' | 'retard' | 'attente';

const STATUS = {
  paye: { label: 'À jour', className: 'text-green-d bg-green-bg-2' },
  retard: { label: 'En retard', className: 'text-red bg-red-bg' },
  attente: { label: 'En attente', className: 'text-gold-d bg-gold-bg' },
} as const;

/**
 * Traduit le résultat du moteur de cotisations (`lib/server/tontine/dues`) en
 * état visuel. `PARTIAL` non échu se lit « en attente » : la maquette n'a pas
 * d'état dédié au paiement partiel.
 */
export function memberStatus(due: {
  status: 'PAID' | 'PARTIAL' | 'UNPAID';
  late: boolean;
}): MemberStatus {
  if (due.status === 'PAID') return 'paye';
  return due.late ? 'retard' : 'attente';
}

export function StatusPill({ status, className }: { status: MemberStatus; className?: string }) {
  const s = STATUS[status];
  return (
    <span
      className={cn(
        'rounded-[20px] px-[11px] py-[4px] text-[12.5px] font-semibold',
        s.className,
        className,
      )}
    >
      {s.label}
    </span>
  );
}

/** Pastille de couleur + nom du moyen de paiement (Wave, Orange Money…). */
export function ModePill({ mode, className }: { mode: PaymentMode; className?: string }) {
  const m = PAYMENT_MODES[mode];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-mut',
        className,
      )}
    >
      <span className="h-[9px] w-[9px] rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
}
